import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core'; // For translations

@Component({
  selector: 'app-input-form-field',
  templateUrl: './input-form-field.component.html',
})
export class InputFormFieldComponent implements OnInit {
  @Input() control: FormControl | any = null; // The form control to manage
  @Input() controlName: string = '';
  @Input() placeholder: string = '';
  @Input() type: string = '';
  @Input() label: string = '';

  constructor(public translate: TranslateService) {}

  ngOnInit(): void {}

  isControlValid(): boolean {
    return this.control ? this.control.valid && this.control.touched : false;
  }

  isControlInvalid(): boolean {
    return this.control ? !this.control.valid && this.control.touched : false;
  }

  controlHasError(error: string): boolean {
    return this.control ? this.control.hasError(error) : false;
  }
}
